import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
// import PreviewBanner from './components/PreviewBanner';
// import DebugEnvironment from './components/DebugEnvironment';
import AppRoutes from './components/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import { AppThemeProvider } from './theme';

/**
 * Main application component that orchestrates the RSM Collective website
 *
 * This component manages:
 * - Error boundary for graceful error handling
 * - Theme provider for consistent styling
 * - CSS baseline for normalized styles
 * - Router setup with scroll-to-top functionality
 * - Delegates all routing logic to AppRoutes component
 *
 * @returns {React.ReactElement} The main application with routing
 */
function App() {
  return (
    <ErrorBoundary>
      <AppThemeProvider>
        {/* <PreviewBanner />
        <DebugEnvironment /> */}
        <Router>
          <ScrollToTop />
          <AppRoutes />
        </Router>
      </AppThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
